<template>
    <section :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
        <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-slate-700' : 'tw-bg-[#e9eef6] tw-border-[#d1d5db]'" class="tw-border-b tw-px-6 tw-py-4 tw-flex tw-items-center tw-gap-3 ">
            <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'" class="tw-p-2.5 tw-rounded-lg ">
                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>report-text</title> <g id="Page-1" stroke="currentColor" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="add" fill="currentColor" transform="translate(42.666667, 85.333333)"> <path d="M341.333333,1.42108547e-14 L426.666667,85.3333333 L426.666667,341.333333 L3.55271368e-14,341.333333 L3.55271368e-14,1.42108547e-14 L341.333333,1.42108547e-14 Z M330.666667,42.6666667 L42.6666667,42.6666667 L42.6666667,298.666667 L384,298.666667 L384,96 L330.666667,42.6666667 Z M149.333333,234.666667 L149.333333,266.666667 L85.3333333,266.666667 L85.3333333,234.666667 L149.333333,234.666667 Z M341.333333,234.666667 L341.333333,266.666667 L192,266.666667 L192,234.666667 L341.333333,234.666667 Z M149.333333,170.666667 L149.333333,202.666667 L85.3333333,202.666667 L85.3333333,170.666667 L149.333333,170.666667 Z M341.333333,170.666667 L341.333333,202.666667 L192,202.666667 L192,170.666667 L341.333333,170.666667 Z M149.333333,106.666667 L149.333333,138.666667 L85.3333333,138.666667 L85.3333333,106.666667 L149.333333,106.666667 Z M341.333333,106.666667 L341.333333,138.666667 L192,138.666667 L192,106.666667 L341.333333,106.666667 Z" id="Combined-Shape"> </path> </g> </g> </g></svg>
            </div>
            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold ">Informações Gerais dos Silos</h3>
        </div>
        <div class="tw-overflow-x-auto custom-scrollbar">
            <table class="tw-w-full">
                <thead>
                    <tr>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">ID</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Descrição</th>
                        <th :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider" colspan="3">Sensores (°C)</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Produto</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Último Registro</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Aeração 24h</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Nível</th>
                        <th rowspan="2" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Status</th>
                    </tr>
                    <tr>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-2 tw-text-xs tw-font-medium tw-text-center tw-uppercase">Mín</td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-2 tw-text-xs tw-font-medium tw-text-center tw-uppercase">Méd</td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-2 tw-text-xs tw-font-medium tw-text-center tw-uppercase">Máx</td>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        v-for="silo in silos" 
                        :key="silo.id" 
                        :class="theme === 'dark' ? 'hover:tw-bg-slate-800/30 tw-border-slate-700' : 'hover:tw-bg-slate-50 tw-border-slate-200'"
                        class="tw-border-t  tw-cursor-pointer"
                        @click="$router.push(`/v2/unidades/${unidade.id}/silos/${silo.id}`)"
                    >
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-center tw-px-6 tw-py-4 tw-text-sm">{{ silo.id }}</td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium">{{ silo.nome }}</td>
                        <td class="tw-px-6 tw-py-4 tw-text-sm tw-text-center">
                            <div class="tw-inline-block tw-px-3 tw-py-1 tw-rounded-full tw-text-white tw-font-semibold tw-text-xs" :style="{ backgroundColor: getCorPorTemperatura(silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.min : 0) }">
                                {{ silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.min : '0' }}
                            </div>
                        </td>
                        <td class="tw-px-6 tw-py-4 tw-text-sm tw-text-center">
                            <div class="tw-inline-block tw-px-3 tw-py-1 tw-rounded-full tw-text-white tw-font-semibold tw-text-xs" :style="{ backgroundColor: getCorPorTemperatura(silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.med : 0) }">
                                {{ silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.med : '0' }}
                            </div>
                        </td>
                        <td class="tw-px-6 tw-py-4 tw-text-sm tw-text-center">
                            <div class="tw-inline-block tw-px-3 tw-py-1 tw-rounded-full tw-text-white tw-font-semibold tw-text-xs" :style="{ backgroundColor: getCorPorTemperatura(silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.max : 0) }">
                                {{ silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.max : '0' }}
                            </div>
                        </td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-4 tw-text-center tw-text-sm ">{{ silo.ultimaleitura ? silo.ultimaleitura.produto : '0' }}</td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-4 tw-text-center tw-text-sm ">{{ silo.ultimaleitura ? silo.ultimaleitura.data : '0' }}</td>
                        <td :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-px-6 tw-py-4 tw-text-center tw-text-sm ">{{ silo.existe_aeracao == 1 ? silo.aeracaoultimas24horas : 'Sem aeração' }}</td>
                        <td class="tw-px-6 tw-py-4 tw-text-sm">
                            <div class="tw-space-y-1">
                                <div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-xs tw-text-center ">{{ (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) % 1 === 0 ? (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) : (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual).toFixed(1) }}%</div>
                                <div :class="theme === 'dark' ? 'tw-bg-slate-600' : 'tw-bg-slate-200'" class="tw-w-full tw-h-2 tw-rounded-full tw-overflow-hidden">
                                    <div class="tw-h-full tw-bg-emerald-500" :style="{ width: (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) + '%' }"></div>
                                </div>
                                <div :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-600'" class="tw-text-center tw-text-xs ">{{ formatarNumero(((silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) / 100) * parseInt(silo.capacidade)) }} / {{ formatarNumero(silo.capacidade) }}</div>
                            </div>
                        </td>
                        <td class="tw-px-6 tw-py-4 tw-text-sm tw-text-center">
                            <span :class="getStatus(silo) === 'Erro' ? (theme === 'dark' ? 'tw-bg-red-500/10 tw-text-red-400' : 'tw-bg-red-50 tw-text-red-600') : (theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600')" class="tw-inline-block tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold tw-uppercase ">{{ getStatus(silo) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
import temperaturaCores from "@/assets/colors.json";
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'DashboardTable',
    props: {
        silos: {
            type: Array,
            required: true
        },
        unidade: {
            type: Array,
            required: true
        }
    },

    setup() {
        const store = useStore();
        const theme = computed(() => store.state.ui.theme);
        const getCorPorTemperatura = (temp) => {
			temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
		};

        const getStatus = (silo) => {
			if (!silo.ultimaleitura || !silo.ultimaleitura.data) return 'Erro';
			const ultimoRegistroStr = silo.ultimaleitura.data;
			
			const [date, time] = ultimoRegistroStr.split(' ');
			const [day, month, year] = date.split('/');
			const [hours, minutes, seconds] = time.split(':');

			const ultimoRegistro = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
			const dataAtual = new Date();
			const diffTime = Math.abs(dataAtual - ultimoRegistro);
			const diffHours = diffTime / (1000 * 3600);
			return diffHours > 12 ? 'Erro' : 'Sucesso';
		};

		const getStatusClass = (silo) => {
			return getStatus(silo) === 'Erro' ? 'text-error' : 'text-success';
		};

        const formatarNumero = (numero) => {
			let numeroInt = parseInt(numero);
			return new Intl.NumberFormat('pt-BR').format(numeroInt);
		};

        return {
            getCorPorTemperatura,
            getStatus,
            getStatusClass,
            formatarNumero,
            theme
        }
    }
}
</script>